import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import ThemeColors from '../../common-components/ThemeColors';
import PageTitle from '../../common-components/PageTitle';
import TopLinearLoading from '../../common-components/TopLinearLoading';
import AppName from '../../common-components/AppName';
import FlexOne from '../../common-components/FlexOne';
import Link from '../../common-components/Link';
import NativeLink from '../../common-components/NativeLink';

import { renderApp } from '../../index';

import * as strings from '../../helpers/strings';

import * as loginReducer from '../reducer';
import * as systemReducer from '../../system/reducer';

import * as loginAction from '../action-creator';
import * as systemAction from '../../system/action-creator';

import { loginBackground } from '../../helpers/constants';

// importing Css
import '../../index.css';

const styles = theme => ({
  loginContainer: {
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      position: "fixed",
      height: "100%",
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      width: "100%",
      backgroundColor: "#000"
    }
  },
  loginCard: {
    position: "relative",
    backgroundColor: "transparent",
    zIndex: 1,
    borderRadius: "4px",
    [theme.breakpoints.up('sm')]: {
      width: 900,
      position: "absolute",
      left: "50%",
      marginLeft: -450,
      top: "50%",
      marginTop: -162
    },
    [theme.breakpoints.down('xs')]: {
      boxShadow: "none",
      backgroundColor: "transparent",
      width: "100%"
    },
  },
  header: { marginBottom: 0 },
  headline: {
    marginBottom: 10,
    color: ThemeColors.primary,
    fontWeight: 100
  },
  signUp: {
    textAlign: "center",
    margin: 0,
    marginTop: 100,
    color: "#000", textDecoration: "none", fontSize: 14,
    [theme.breakpoints.up('sm')]: {
      marginTop: 20,
    },
  },
  secondaryLink: {
    marginBottom: 10,
    cursor: "pointer",
    color: '#42A5F5'
  },
  subheading: {
    color: "#000",
    marginTop: 10
  },
  failedMessage: { fontSize: 11, color: "red", height: 21 },
  lightHeader: { fontWeight: 400, fontSize: '1.25rem', color: '#FFF', margin: '0 !important', paddingTop: '2rem', paddingBottom: '1rem' },
  serisContainer: {
    borderRight: "1px solid rgba(0,0,0,0.1)",
    textAlign: "center",
    padding: 16,
    position: "relative",
    background: "rgba(52, 58, 64,0.47)",
    // background: "rgba(237,238,239,0.85)",
    borderRadius: "4px 0px 0px 4px",
    '& a': {
      color: '#FFF !important'
    }
  },
  signInGridItem: {
    padding: "16px",
    background: "#ffffffb0",
    borderRadius: "0px 4px 4px 0px"
  },
  signInGridInnerStyle: {
    '& > a': {
      color: '#343A40 !important'
    }
  },
  loginButton: {
    '&:hover': {
      boxShadow: '10px 0 30px -5px rgba(255, 175, 123, 0.7), -10px 0 30px -5px rgba(42, 59, 90, 0.7)',
      transition: 'box-shadow 0.3s ease-in-out',
    },
    color: '#FFF',
    transition: 'box-shadow 0.3s ease-in-out', 
  },
  iconButton: {
    '&:focus': {
      outline: 'none', // Removes the browser default outline
    },
  },
  loginInputRoot: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.MuiFilledInput-root': {
      backgroundColor: 'transparent',
    },
    '&.MuiFilledInput-root:hover': {
      backgroundColor: 'transparent',
    },
    '&.MuiFilledInput-root.Mui-focused': {
      backgroundColor: 'transparent',
    },
  },
  loginInput: {
    backgroundColor: 'transparent',
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px transparent inset',
      WebkitTextFillColor: 'inherit',
      caretColor: 'inherit',
      transition: 'background-color 5000s ease-in-out 0s',
    },
    '&:-webkit-autofill:hover': {
      WebkitBoxShadow: '0 0 0 100px transparent inset',
      WebkitTextFillColor: 'inherit',
    },
    '&:-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 100px transparent inset',
      WebkitTextFillColor: 'inherit',
    },
  },
});

class Login extends Component {

  constructor() {
    super();

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handlePasswordKeyDown = this.handlePasswordKeyDown.bind(this);

    this.state = {
      loading: false,
      showPassword: false
    }
  }
  componentDidMount() {
    if (window.location.pathname === '/login') {
      document.body.style.backgroundImage = `url("${loginBackground}")`;
      document.body.style.backgroundSize = 'cover'; // Optional: Adjust the image size to cover the entire background
      document.body.style.backgroundRepeat = 'no-repeat';
      document.body.style.backgroundAttachment = 'fixed';
    }
  }
  
  componentDidUpdate(prevProps) {
    // Reset loading state when login fails (error message appears)
    if (this.state.loading && this.props.loginFailedMessage && !prevProps.loginFailedMessage) {
      this.setState({ loading: false });
    }
    // Reset loading state when login succeeds (user is no longer logging in)
    if (this.state.loading && prevProps.isLoggingIn && !this.props.isLoggingIn && !this.props.loginFailedMessage) {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    if (window.location.pathname === '/login') {
      document.body.style.backgroundImage = 'none';
      document.body.style.backgroundSize = 'initial'; // Optional: Reset the background size if needed
    }
  }
  

  handlePasswordKeyDown(e) {
    if ("Enter" === e.key && this.props.isValid) {
      this.handleLogin();
    }
  }

  handleEmailChange(e) {
    this.props.setEmail(e.target.value);
  }

  handlePasswordChange(e) {
    this.props.setPassword(e.target.value);
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  handleLogin() {
    const { login, email, password } = this.props;
    login(email, password, renderApp);
    this.setState({ loading: true })
  }

  render() {
    const { passwordError, emailError, email, password, isLoggingIn, isValid, loginFailedMessage, classes } = this.props;
    const { showPassword } = this.state;

    return (
      <div className={classes.loginContainer}>
        {/* {isLoggingIn && <Hidden smUp><TopLinearLoading/></Hidden>} */}
        <Paper className={classes.loginCard}>
          {(this.state.loading && loginFailedMessage === "") ? <TopLinearLoading /> : null}
          <div>
            <Grid container>
              <Grid item sm={6} xs={12} className={classes.serisContainer}>
                <Hidden xsDown><h5 className={classes.lightHeader}>Powered by</h5></Hidden>
                <img src="/images/seris-logo-light.png" alt={strings.appName} />
                <Hidden xsDown>
                  <h3 className={classes.lightHeader}>Solar Energy Research Institute of Singapore</h3>
                  <NativeLink href="http://www.seris.nus.edu.sg/" rel="noopener noreferrer" target="_blank" text="Visit www.seris.nus.edu.sg" style={{
                    position: "absolute",
                    bottom: 23,
                    display: "inline-block",
                    width: "100%",
                    left: 0
                  }} />
                </Hidden>
              </Grid>
              <Grid item sm={6} xs={12} className={classes.signInGridItem}>
                <div className={classes.header}>
                  <PageTitle title={<AppName name="SERIS Real-time Analytical Monitoring System" />} />
                  <Typography className={classes.subheading}>{strings.lblSignInWithYourEmailAndPassword}</Typography>
                </div>
                <div>
                  <TextField
                    fullWidth={true}
                    label={strings.lblEmail}
                    onChange={this.handleEmailChange}
                    value={email}
                    type="email"
                    margin="normal"
                    helperText={emailError}
                    error={!!emailError}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      classes: {
                        root: classes.loginInputRoot,
                        input: classes.loginInput,
                      },
                    }}
                  />
                  <TextField
                    fullWidth={true}
                    label={strings.lblPassword}
                    onChange={this.handlePasswordChange}
                    onKeyDown={this.handlePasswordKeyDown}
                    value={password}
                    margin="normal"
                    helperText={passwordError}
                    error={!!passwordError}
                    type={showPassword ? 'text' : 'password'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      classes: {
                        root: classes.loginInputRoot,
                        input: classes.loginInput,
                      },
                      endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                                onClick={this.handleClickShowPassword}
                                className={classes.iconButton}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                      ),
                    }}
                  />
                  <p className={classes.failedMessage}>{loginFailedMessage}</p>
                  <Grid container alignItems="center" className={classes.signInGridInnerStyle}>
                    <Link url="/forget-password" text={strings.lblForgetPassword} />
                    <FlexOne />
                    <Button variant={strings.btnRaised} color={strings.colorPrimary} onClick={this.handleLogin} disabled={!isValid} className={classes.loginButton}>{strings.lblSignIn}</Button>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  email: loginReducer.getEmail(state),
  password: loginReducer.getPassword(state),
  emailError: loginReducer.getEmailError(state),
  passwordError: loginReducer.getPasswordError(state),
  isValid: loginReducer.getIsValid(state),
  isLoggingIn: systemReducer.getIsLoggingIn(state),
  loginFailedMessage: loginReducer.getLogInFailedMessage(state)
});

const mapActionsToFuncs = {
  login: systemAction.login,
  ...loginAction
};

export default connect(mapStateToProps, mapActionsToFuncs)(
  withStyles(styles)(Login)
);